import React, { useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

import ReactPlayer from "react-player/youtube";
import CountUp from "react-countup";

import { RoadMap } from "../../../Components/Home/RoadMap/RoadMap.tsx";

import { useAppSelector, useAppDispatch } from "../../../store";
import { getPublickNews } from "../../../features/news/newsSlice";
import {
  getHomeStat,
  getLastOperations,
} from "../../../features/home/homeSlice";
import { getPublickReviews } from "../../../features/review/reviewSlice";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import { replaceSymbolToDots } from "../../../utils/replaceSymbolToDots";

import { motion } from "framer-motion";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Moment from "react-moment";

import { Avatar, Flex, Text, useMediaQuery } from "@chakra-ui/react";
import { LangEnum } from "../../Dashboard/NewsList";
import Meta from "../../../utils/seo/Meta";

const Main = () => {
  const { t } = useTranslation();

  const { userData } = useAppSelector((state) => state.userInfo);
  const { publicNews } = useAppSelector((state) => state.news);
  const { publicReviews } = useAppSelector((state) => state.review);
  const { stat, lastOperations } = useAppSelector((state) => state.home);

  const [isLargerThan770] = useMediaQuery("(min-width: 770px)");

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  //Framer motion
  const whileHover = {
    scale: 1.1,
    transition: { duration: 0.1 },
    color: "#009CFF",
  };
  //Framer motion
  const textAnimation = {
    hidden: {
      x: -300,
      opacity: 0,
    },
    visible: (custom) => ({
      x: 0,
      opacity: 1,
      transition: {
        delay: custom * 2,
        duration: 1,
        type: "just",
      },
    }),
  };

  //Framer motion
  const listAnimation = {
    hidden: {
      y: 300,
      opacity: 0,
    },
    visible: (custom) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: custom * 0.15,
        duration: 1,
        type: "just",
      },
    }),
  };
  //Framer motion
  const imageAnimation = {
    hidden: {
      y: -200,
      opacity: 0,
    },
    visible: (custom) => ({
      y: 0,
      opacity: 1,
      transition: { delay: custom * 2 },
    }),
  };

  // Get news and reviews when page load
  useEffect(() => {
    const reviewData = {
      skip: 0,
      take: 4,
    };
    dispatch(getPublickNews());
    dispatch(getPublickReviews(reviewData));
  }, []);

  // Get statistic when page load
  useEffect(() => {
    dispatch(getHomeStat());
  }, []);

  // Get home last operations when page load
  useEffect(() => {
    const data = {
      skip: 0,
      take: 10,
    };
    dispatch(getLastOperations(data));
  }, []);

  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="slick__dot ' + className + '"></span>';
    },
  };

  // Get Days between
  const daysBetween = () => {
    const milliseconds = new Date("2022-10-17").getTime();
    const toDay = new Date().getTime();
    const one_day = 1000 * 60 * 60 * 24;
    const difference = Math.round((toDay - milliseconds) / one_day);
    return difference;
  };

  return (
    <>
      <Meta
        title="Main"
        description="Мы работаем с 2021 года в сфере криптовалюты и финансов и открываем новое направление –
        матричные партнерские программы."
      />
      <div className="arg">
        <img alt="Картинка" src="/assets/img/main.jpg" className="arg__img" />

        <div className="container">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.8 }}
            className="arg__inner"
          >
            <div className="arg__item">
              <motion.img
                custom={0.4}
                variants={imageAnimation}
                src="/assets/img/main-point1.svg"
                alt="Иконка"
                className="arg__item--icon"
              />

              <div className="arg__item--wrapper">
                <motion.p
                  custom={0.5}
                  variants={textAnimation}
                  className="arg__item--title"
                >
                  {t("Main.title1")}
                </motion.p>

                <motion.p
                  custom={0.6}
                  variants={textAnimation}
                  className="arg__item--text"
                >
                  {t("Main.description1")}
                </motion.p>
              </div>
            </div>

            <div className="arg__item">
              <motion.img
                custom={0.7}
                variants={imageAnimation}
                src="/assets/img/main-point2.svg"
                alt="Иконка"
                className="arg__item--icon"
              />

              <div className="arg__item--wrapper">
                <motion.p
                  custom={0.8}
                  variants={textAnimation}
                  className="arg__item--title"
                >
                  {t("Main.title2")}
                </motion.p>

                <motion.p
                  custom={0.9}
                  variants={textAnimation}
                  className="arg__item--text"
                >
                  {t("Main.description2")}
                </motion.p>
              </div>
            </div>

            <div className="arg__item">
              <motion.img
                custom={1}
                variants={imageAnimation}
                src="/assets/img/main-point3.svg"
                alt="Иконка"
                className="arg__item--icon"
              />

              <div className="arg__item--wrapper">
                <motion.p
                  custom={1.1}
                  variants={textAnimation}
                  className="arg__item--title"
                >
                  {t("Main.title3")}
                </motion.p>

                <motion.p
                  custom={1.2}
                  variants={textAnimation}
                  className="arg__item--text"
                >
                  {t("Main.description3")}
                </motion.p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="main">
        <img
          alt="Картинка"
          src="/assets/img/dots.png"
          className="main__dots2"
        />
        <img
          alt="Картинка"
          src="/assets/img/circle3.png"
          className="main__circle2"
        />

        <div className="container">
          <div className="mains__inner">
            <div className="main__text--inner">
              <p className="text__name">Dreams Come True</p>

              <p className="mains__text">{t("Main.description4")}</p>

              <p className="mains__text">{t("Main.description5")}</p>

              <p className="mains__text">{t("Main.description6")}</p>

              <motion.button
                onClick={() => navigate("/register")}
                className="button default__button mains__button"
              >
                {t("Main.work")}
              </motion.button>
            </div>

            <div className="main__video--inner">
              <ReactPlayer
                url="https://youtu.be/OqadCOS1wPo"
                controls={true}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="company">
        <div className="container">
          <div className="company__inner">
            <p className="company__title">{t("Main.about")}</p>

            <p className="company__text company__margin">
              {t("Main.description7")}
            </p>

            <p className="company__text">{t("Main.description8")}</p>
          </div>
        </div>
      </div>

      <div className="vector company__bg">
        <div className="container">
          <div className="vector__inner">
            <div className="vector__content company__content">
              <motion.div whileHover={whileHover} className="vector__item">
                <svg
                  className="vector__item--icon"
                  width="40"
                  height="30"
                  viewBox="0 0 40 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M39.8126 8.19124L32.0549 0.433396C31.8054 0.183866 31.401 0.183866 31.1514 0.433396L27.2725 4.31228C27.1527 4.43204 27.0854 4.59454 27.0854 4.764C27.0854 4.93345 27.1527 5.09595 27.2725 5.21571L27.6594 5.60266L26.7702 6.49172C26.193 7.06875 25.2973 7.22625 24.5415 6.8832C23.8329 6.56156 23.0452 6.39164 22.2633 6.39164C21.3349 6.39164 20.4277 6.62469 19.6216 7.06609C19.2854 6.98328 18.9404 6.94086 18.592 6.94086C18.0881 6.94086 17.5932 7.02781 17.121 7.19945C16.367 7.47336 15.5588 7.30359 15.0114 6.75633L13.4147 5.15962L13.6049 4.96946C13.7247 4.8497 13.7919 4.6872 13.7919 4.51775C13.7919 4.34829 13.7247 4.1858 13.6049 4.06603L9.72602 0.187147C9.47641 -0.0623824 9.07204 -0.0623824 8.82251 0.187147L0.187089 8.82257C-0.0623629 9.0721 -0.0623629 9.47655 0.187089 9.726L4.06589 13.6049C4.18574 13.7247 4.34816 13.792 4.51769 13.792C4.68722 13.792 4.84956 13.7247 4.96948 13.6049L5.20081 13.3736L6.3269 14.4996C6.61104 14.7838 6.79939 15.1385 6.8715 15.5255C7.24541 17.532 8.20634 19.3561 9.65039 20.8009L9.8625 21.013C9.45516 21.442 9.2311 22.0009 9.2311 22.5947C9.2311 23.2088 9.47032 23.7862 9.90453 24.2205C10.3528 24.6688 10.9415 24.8929 11.5304 24.8929C11.5687 24.8929 11.6069 24.8918 11.6453 24.8899C11.6142 25.5164 11.8373 26.1532 12.3147 26.6307C12.749 27.065 13.3264 27.3041 13.9405 27.3041C13.9576 27.3041 13.9747 27.3032 13.9918 27.3028C13.9786 27.9082 14.202 28.5178 14.6629 28.9789C15.0972 29.4132 15.6747 29.6523 16.2889 29.6523C16.903 29.6523 17.4803 29.4131 17.9147 28.9789C17.9513 28.9423 17.9857 28.9045 18.0194 28.8662C18.2456 28.945 18.4848 28.987 18.7266 28.987C19.301 28.987 19.8407 28.7632 20.2454 28.3571C20.4608 28.1418 20.6242 27.8885 20.7306 27.6127L20.796 27.6781C21.2147 28.0968 21.7646 28.3061 22.3145 28.3061C22.8645 28.3061 23.4144 28.0968 23.833 27.6781C24.0555 27.4556 24.2227 27.1928 24.3287 26.9064C24.7034 27.1789 25.1471 27.3154 25.591 27.3154C26.1409 27.3154 26.6912 27.1061 27.1102 26.6876C27.5158 26.2821 27.7391 25.7425 27.7391 25.1685C27.7391 24.9951 27.7183 24.825 27.6787 24.6605C28.0879 24.5774 28.4638 24.3765 28.7654 24.0745C29.171 23.669 29.3943 23.1297 29.3943 22.556C29.3943 22.1041 29.2551 21.6738 28.998 21.313L29.5105 20.8005C30.9714 19.339 31.9364 17.492 32.3015 15.4591C32.3627 15.1187 32.5313 14.8025 32.7892 14.5445L34.6953 12.6384L35.0304 12.9735C35.1552 13.0982 35.3187 13.1606 35.4822 13.1606C35.6456 13.1606 35.8092 13.0982 35.934 12.9735L39.8129 9.0946C39.9326 8.97483 39.9999 8.81233 39.9999 8.64288C39.9999 8.47343 39.9324 8.31108 39.8126 8.19124ZM4.51769 12.2498L1.54224 9.27436L9.27415 1.54245L12.2497 4.5179L4.51769 12.2498ZM12.2527 23.3172C11.8545 23.7154 11.2065 23.7155 10.808 23.3172C10.615 23.1242 10.5087 22.8677 10.5087 22.5948C10.5087 22.322 10.6151 22.0655 10.808 21.8725C11.0072 21.6734 11.2687 21.5737 11.5303 21.5737C11.7919 21.5737 12.0536 21.6734 12.2526 21.8725C12.6509 22.2708 12.6509 22.9189 12.2527 23.3172ZM14.6627 25.7272C14.4699 25.9203 14.2134 26.0265 13.9404 26.0265C13.6676 26.0265 13.411 25.9201 13.2181 25.7272C12.8197 25.329 12.8197 24.6808 13.2181 24.2825C13.4172 24.0833 13.6787 23.9837 13.9404 23.9837C14.2019 23.9837 14.4636 24.0833 14.6627 24.2825C15.0611 24.6808 15.0611 25.329 14.6627 25.7272ZM17.011 28.0754C16.818 28.2684 16.5615 28.3746 16.2887 28.3746C16.0158 28.3746 15.7593 28.2683 15.5664 28.0754C15.168 27.6771 15.168 27.029 15.5664 26.6307C15.7655 26.4315 16.027 26.3319 16.2887 26.3319C16.5502 26.3319 16.8119 26.4315 17.011 26.6307C17.4093 27.029 17.4093 27.6771 17.011 28.0754ZM27.8615 23.1714C27.6973 23.3358 27.479 23.4263 27.2468 23.4263C27.0146 23.4263 26.7962 23.3358 26.6317 23.171L20.4341 16.9748C20.1844 16.7253 19.78 16.7254 19.5306 16.9749C19.2812 17.2244 19.2813 17.6289 19.5307 17.8784L26.2065 24.5535C26.3708 24.7177 26.4612 24.9361 26.4612 25.1685C26.4612 25.4013 26.3708 25.62 26.2068 25.784C25.8672 26.1232 25.3149 26.1233 24.9759 25.7842L23.8496 24.6579C23.8434 24.6515 23.8373 24.6449 23.8308 24.6385C23.8289 24.6366 23.8268 24.635 23.8248 24.6331L18.6478 19.456C18.3982 19.2066 17.9938 19.2066 17.7443 19.456C17.4947 19.7055 17.4947 20.11 17.7443 20.3595L22.938 25.5531C23.0967 25.7158 23.1841 25.9311 23.1841 26.1596C23.1841 26.3919 23.0936 26.6104 22.9294 26.7746C22.5905 27.1137 22.0387 27.1137 21.6995 26.7746L16.0679 21.1429C15.8182 20.8934 15.4139 20.8934 15.1643 21.1429C14.9148 21.3923 14.9148 21.7969 15.1643 22.0463L19.3389 26.2209C19.34 26.2221 19.341 26.2234 19.3422 26.2245C19.5064 26.3883 19.5967 26.6064 19.5967 26.8385C19.5967 27.0707 19.5062 27.2892 19.3413 27.4541C19.1773 27.6185 18.959 27.709 18.7264 27.709C18.6703 27.709 18.6153 27.7032 18.5616 27.6931C18.665 26.9968 18.4494 26.2618 17.9146 25.7269C17.4803 25.2927 16.9029 25.0535 16.2887 25.0535C16.2716 25.0535 16.2546 25.0543 16.2375 25.0547C16.2506 24.4493 16.0273 23.8397 15.5663 23.3787C15.1319 22.9445 14.5546 22.7053 13.9404 22.7053C13.9019 22.7053 13.8637 22.7062 13.8256 22.7081C13.8563 22.082 13.6332 21.4458 13.1561 20.9686C12.5753 20.3879 11.7589 20.1839 11.012 20.3555L10.5539 19.8974C9.29297 18.6359 8.45407 17.0431 8.12759 15.2912C8.00798 14.6496 7.69775 14.0633 7.23049 13.596L6.10432 12.4698L12.5113 6.06282L14.108 7.65953C14.7218 8.27327 15.5574 8.60171 16.4132 8.60171C16.7965 8.60171 17.1841 8.53577 17.5575 8.40007C17.7386 8.33421 17.9258 8.28694 18.1156 8.25694L14.16 12.2126C13.676 12.6965 13.4094 13.34 13.4094 14.0244C13.4094 14.7088 13.676 15.3522 14.1599 15.8361C14.6594 16.3356 15.3154 16.5853 15.9716 16.5853C16.6277 16.5853 17.2839 16.3354 17.7835 15.8361L19.7702 13.8494L20.3079 14.3875C20.3078 14.3874 20.3081 14.3877 20.3079 14.3875L20.3521 14.4318C20.352 14.4317 20.3522 14.4318 20.3521 14.4318L20.3529 14.4325C20.3591 14.4385 20.3651 14.4443 20.3711 14.4501L27.8618 21.9408C28.0261 22.105 28.1165 22.3234 28.1165 22.5558C28.1165 22.7885 28.0261 23.0069 27.8615 23.1714ZM31.8855 13.6411C31.4422 14.0845 31.1511 14.6351 31.0438 15.2334C30.725 17.0084 29.8823 18.6212 28.6068 19.8973L28.1159 20.3883L24.0744 16.3468C24.1623 16.3533 24.2505 16.3576 24.3393 16.3576C24.7485 16.3576 25.1673 16.2859 25.5841 16.1153C25.9107 15.9817 26.0671 15.6087 25.9335 15.2822C25.7999 14.9557 25.4272 14.7993 25.1004 14.9328C23.4562 15.6056 21.4849 13.7516 21.2655 13.5379C21.2618 13.5343 21.2581 13.5308 21.2544 13.5274L21.2317 13.5047C21.2318 13.5048 21.2317 13.5046 21.2317 13.5047L21.2117 13.4849C21.2119 13.485 21.2117 13.4848 21.2117 13.4849L20.6735 12.9464L21.2834 12.3365C21.533 12.0869 21.533 11.6825 21.2835 11.4329C21.0339 11.1836 20.6295 11.1835 20.38 11.4329L19.3199 12.4931C19.3195 12.4935 19.319 12.4939 19.3186 12.4943C19.3182 12.4947 19.3178 12.4951 19.3174 12.4955L16.88 14.933C16.379 15.4339 15.5642 15.4337 15.0634 14.933C14.8208 14.6904 14.6872 14.3678 14.6872 14.0247C14.6872 13.6816 14.8208 13.359 15.0635 13.1164L19.2707 8.90913C19.5047 8.67515 19.7649 8.46929 20.0445 8.29687C20.7088 7.88624 21.476 7.66921 22.2633 7.66921C22.8643 7.66921 23.4695 7.79968 24.0135 8.04663C25.2512 8.60819 26.7222 8.34655 27.6737 7.39523L28.563 6.5061L33.7918 11.7349L31.8855 13.6411ZM35.482 11.6185L28.6276 4.76415L31.6032 1.7887L38.4575 8.64304L35.482 11.6185Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M36.1256 9.77035C36.4784 9.77035 36.7644 9.48434 36.7644 9.13152C36.7644 8.77871 36.4784 8.4927 36.1256 8.4927C35.7728 8.4927 35.4868 8.77871 35.4868 9.13152C35.4868 9.48434 35.7728 9.77035 36.1256 9.77035Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M4.18491 10.4015C4.53773 10.4015 4.82374 10.1155 4.82374 9.7627C4.82374 9.40988 4.53773 9.12387 4.18491 9.12387C3.8321 9.12387 3.54609 9.40988 3.54609 9.7627C3.54609 10.1155 3.8321 10.4015 4.18491 10.4015Z"
                    fill="#ACBDCE"
                  />
                </svg>

                <p className="vector__item--title">{t("Main.title9")}</p>

                <p className="vector__item--text">{t("Main.description9")}</p>
              </motion.div>

              <motion.div whileHover={whileHover} className="vector__item">
                <svg
                  className="vector__item--icon"
                  width="39"
                  height="39"
                  viewBox="0 0 39 39"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M39 19.5C39 8.74795 30.252 0 19.5 0C16.129 0 12.8448 0.873097 9.93305 2.51613H7.54839V0H3.77419V7.98053C1.30839 11.3396 0 15.315 0 19.5C0 30.2527 8.74795 39 19.5 39C21.896 39 24.2347 38.5691 26.4521 37.7224C27.7177 38.527 29.2148 39 30.8226 39C32.7839 39 34.6811 38.2949 36.1643 37.0148L35.3422 36.0624C34.0873 37.1456 32.4826 37.7419 30.8226 37.7419C27.0075 37.7419 23.9032 34.6377 23.9032 30.8226C23.9032 27.0075 27.0075 23.9032 30.8226 23.9032C34.6377 23.9032 37.7419 27.0075 37.7419 30.8226C37.7419 32.4172 37.2148 33.9162 36.2165 35.1572L37.1972 35.946C38.3596 34.4999 39 32.6807 39 30.8226C39 29.2135 38.5263 27.7164 37.7212 26.4502C38.5672 24.2322 39 21.896 39 19.5ZM10.0645 6.29032H11.3226V15.0968H10.0645V6.29032ZM7.54839 3.77419H8.80645V15.0968H7.54839V3.77419ZM5.03226 1.25806H6.29032V15.0968H5.03226V1.25806ZM18.871 37.7262C9.31219 37.3997 1.60026 29.6878 1.27379 20.129H18.871V37.7262ZM18.871 18.871H1.28323C1.38576 15.8088 2.23621 12.8826 3.77419 10.274V16.3548H17.6129V10.0645H15.0968V7.54839H12.5806V5.03226H10.0645V3.89497C12.726 2.28213 15.7503 1.38702 18.871 1.28008V18.871ZM12.5806 15.0968V8.80645H13.8387V15.0968H12.5806ZM15.0968 15.0968V11.3226H16.3548V15.0968H15.0968ZM37.7262 18.871H32.3411L36.967 14.2451C37.4111 15.7176 37.6715 17.2682 37.7262 18.871ZM34.5565 9.21532L27.5309 16.241L28.4203 17.1304L35.2453 10.3054C35.7334 11.1383 36.1568 12.0126 36.5103 12.9228L30.5622 18.871H26.6798L27.4931 18.0576L26.6037 17.1682L24.9009 18.871H21.0185L32.8273 7.06215C33.4551 7.73521 34.0344 8.45356 34.5565 9.21532ZM20.129 1.27379C21.7318 1.32852 23.2824 1.58894 24.7549 2.03303L20.129 6.65894V1.27379ZM20.129 14.0991L27.7737 6.4545L26.8842 5.56505L20.129 12.3202V8.43784L26.0772 2.48971C26.9874 2.8426 27.8617 3.26594 28.6946 3.75469L27.6812 4.76806L28.5706 5.65752L29.7847 4.44348C30.5464 4.96558 31.2648 5.54429 31.9379 6.17269L20.129 17.9815V14.0991ZM30.8226 22.6452C26.3137 22.6452 22.6452 26.3137 22.6452 30.8226C22.6452 33.1884 23.661 35.3158 25.272 36.8103C23.6145 37.3633 21.8903 37.6683 20.129 37.7275V20.129H37.7275C37.6683 21.8897 37.3607 23.6126 36.8084 25.2701C35.3139 23.6598 33.1871 22.6452 30.8226 22.6452Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M15.2838 22.8292L7.73535 30.3777L8.62493 31.2672L16.1734 23.7188L15.2838 22.8292Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M14.4677 27.6774C13.4273 27.6774 12.5806 28.5241 12.5806 29.5645C12.5806 30.6049 13.4273 31.4516 14.4677 31.4516C15.5081 31.4516 16.3548 30.6049 16.3548 29.5645C16.3548 28.5241 15.5081 27.6774 14.4677 27.6774ZM14.4677 30.1936C14.1211 30.1936 13.8387 29.9118 13.8387 29.5645C13.8387 29.2173 14.1211 28.9355 14.4677 28.9355C14.8143 28.9355 15.0968 29.2173 15.0968 29.5645C15.0968 29.9118 14.8143 30.1936 14.4677 30.1936Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M9.43548 22.6452C8.39506 22.6452 7.54838 23.4919 7.54838 24.5323C7.54838 25.5727 8.39506 26.4194 9.43548 26.4194C10.4759 26.4194 11.3226 25.5727 11.3226 24.5323C11.3226 23.4919 10.4759 22.6452 9.43548 22.6452ZM9.43548 25.1613C9.08888 25.1613 8.80644 24.8795 8.80644 24.5323C8.80644 24.185 9.08888 23.9032 9.43548 23.9032C9.78207 23.9032 10.0645 24.185 10.0645 24.5323C10.0645 24.8795 9.78207 25.1613 9.43548 25.1613Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M30.8226 30.1936C30.1288 30.1936 29.5645 29.6293 29.5645 28.9355C29.5645 28.2417 30.1288 27.6774 30.8226 27.6774C31.5164 27.6774 32.0806 28.2417 32.0806 28.9355H33.3387C33.3387 27.7661 32.5335 26.7899 31.4516 26.5087V25.1613H30.1935V26.5087C29.1116 26.7899 28.3064 27.7661 28.3064 28.9355C28.3064 30.3231 29.4349 31.4516 30.8226 31.4516C31.5164 31.4516 32.0806 32.0159 32.0806 32.7097C32.0806 33.4035 31.5164 33.9678 30.8226 33.9678C30.1288 33.9678 29.5645 33.4035 29.5645 32.7097H28.3064C28.3064 33.8791 29.1116 34.8553 30.1935 35.1365V36.4839H31.4516V35.1365C32.5335 34.8553 33.3387 33.8791 33.3387 32.7097C33.3387 31.322 32.2102 30.1936 30.8226 30.1936Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M36.4839 30.1936H35.2258V31.4516H36.4839V30.1936Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M26.4194 30.1936H25.1613V31.4516H26.4194V30.1936Z"
                    fill="#ACBDCE"
                  />
                </svg>

                <p className="vector__item--title">{t("Main.title10")}</p>

                <p className="vector__item--text">{t("Main.description10")}</p>
              </motion.div>

              <motion.div whileHover={whileHover} className="vector__item">
                <svg
                  className="vector__item--icon"
                  width="31"
                  height="40"
                  viewBox="0 0 31 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M29.7062 40H23.7031C23.3794 40 23.1171 39.7377 23.1171 39.4141C23.1171 39.0904 23.3794 38.8281 23.7031 38.8281H29.1203V1.17188H16.2148C15.8911 1.17188 15.6289 0.909609 15.6289 0.585938C15.6289 0.262266 15.8911 0 16.2148 0H29.7062C30.0299 0 30.2921 0.262266 30.2921 0.585938V39.4141C30.2921 39.7377 30.0299 40 29.7062 40Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M21.1492 38.8281H1.17187V1.17188H13.6609C13.9846 1.17188 14.2469 0.909609 14.2469 0.585938C14.2469 0.262266 13.9846 0 13.6609 0H0.585937C0.262265 0 0 0.262266 0 0.585938V39.4141C0 39.7377 0.262265 40 0.585937 40H21.1492C21.4729 40 21.7352 39.7377 21.7352 39.4141C21.7352 39.0904 21.4728 38.8281 21.1492 38.8281Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M27.2797 14.4648C27.6033 14.4648 27.8656 14.2026 27.8656 13.8789V5.9867C27.8012 5.29647 27.4236 4.91889 26.7328 4.85389C25.9443 4.7796 25.513 4.34803 25.439 3.55936C25.439 2.93475 24.9308 2.42655 24.3062 2.42655H5.98591C5.29544 2.49131 4.91786 2.86889 4.8531 3.55936C4.77904 4.34819 4.34779 4.77967 3.55935 4.85389C2.93474 4.85389 2.42654 5.36209 2.42654 5.9867V34.0133C2.49099 34.7041 2.86911 35.0817 3.56091 35.1461C4.27341 35.1461 4.8531 35.7261 4.8531 36.4391C4.8531 37.0637 5.3613 37.5719 5.98591 37.5719H24.3062C24.9308 37.5719 25.439 37.0637 25.439 36.4391C25.439 35.7261 26.019 35.1461 26.7328 35.1461C27.3574 35.1461 27.8656 34.6379 27.8656 34.0133V16.4328C27.8656 16.1091 27.6033 15.8469 27.2797 15.8469C26.956 15.8469 26.6937 16.1091 26.6937 16.4328V33.9745C25.3651 33.9948 24.2882 35.0715 24.2675 36.4H6.02466C6.00396 35.0718 4.92771 33.9952 3.59841 33.9745V6.02545C4.91349 6.00522 6.00443 4.91335 6.02466 3.59842H24.2675C24.2774 4.24256 24.5329 4.8467 24.989 5.30295C25.445 5.75983 26.049 6.01553 26.6936 6.02545V13.8789C26.6937 14.2026 26.956 14.4648 27.2797 14.4648Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M22.4263 7.28031H7.86579C7.54212 7.28031 7.27985 7.54257 7.27985 7.86624C7.27985 8.18991 7.54212 8.45218 7.86579 8.45218H22.4262C22.7499 8.45218 23.0121 8.18991 23.0121 7.86624C23.0121 7.54257 22.7499 7.28031 22.4263 7.28031Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M19.9995 10.879C20.3231 10.879 20.5854 10.6167 20.5854 10.2931C20.5854 9.9694 20.3231 9.70713 19.9995 9.70713H10.2926C9.96891 9.70713 9.70665 9.9694 9.70665 10.2931C9.70665 10.6167 9.96891 10.879 10.2926 10.879H19.9995Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M15.1461 32.6374C15.4698 32.6374 15.732 32.3751 15.732 32.0515V31.3402C16.605 31.217 17.2787 30.465 17.2787 29.5586C17.2787 28.5665 16.4715 27.7593 15.4794 27.7593H14.8129C14.4669 27.7593 14.1855 27.4779 14.1855 27.1319C14.1855 26.786 14.467 26.5045 14.8129 26.5045H15.4084C15.6355 26.5045 15.8319 26.6507 15.8972 26.8682C15.9902 27.1782 16.3174 27.3542 16.6268 27.261C16.9368 27.168 17.1127 26.8413 17.0196 26.5313C16.8362 25.9201 16.3386 25.4799 15.7321 25.3632V24.639C15.7321 24.3153 15.4699 24.053 15.1462 24.053C14.8225 24.053 14.5602 24.3153 14.5602 24.639V25.3502C13.6873 25.4734 13.0136 26.2254 13.0136 27.1318C13.0136 28.124 13.8208 28.9311 14.8129 28.9311H15.4794C15.8254 28.9311 16.1068 29.2126 16.1068 29.5586C16.1068 29.9045 15.8253 30.1859 15.4794 30.1859H14.7277C14.5006 30.1859 14.3042 30.0397 14.2388 29.8222C14.1459 29.5122 13.8188 29.3365 13.5092 29.4294C13.1992 29.5224 13.0234 29.8491 13.1164 30.1591C13.3153 30.8221 13.8839 31.2839 14.5602 31.3497V32.0515C14.5602 32.375 14.8224 32.6374 15.1461 32.6374Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M22.4263 14.5607H7.86579C7.54212 14.5607 7.27985 14.8229 7.27985 15.1466C7.27985 15.4703 7.54212 15.7325 7.86579 15.7325H22.4262C22.7499 15.7325 23.0121 15.4703 23.0121 15.1466C23.0121 14.8229 22.7499 14.5607 22.4263 14.5607Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M23.0122 20.0025C23.0122 19.6788 22.7499 19.4166 22.4263 19.4166H7.86579C7.54212 19.4166 7.27985 19.6788 7.27985 20.0025C7.27985 20.3262 7.54212 20.5885 7.86579 20.5885H22.4262C22.7498 20.5885 23.0122 20.3262 23.0122 20.0025Z"
                    fill="#ACBDCE"
                  />
                  <path
                    d="M22.4263 16.8801H7.86579C7.54212 16.8801 7.27985 17.1424 7.27985 17.466C7.27985 17.7897 7.54212 18.052 7.86579 18.052H22.4262C22.7499 18.052 23.0121 17.7897 23.0121 17.466C23.0121 17.1424 22.7499 16.8801 22.4263 16.8801Z"
                    fill="#ACBDCE"
                  />
                </svg>

                <p className="vector__item--title">{t("Main.title11")}</p>

                <p className="vector__item--text">
                  {t("Main.description11")}{" "}
                  <a
                    className="vector__item--text"
                    href="https://find-and-update.company-information.service.gov.uk/company/13247736"
                    style={{
                      textDecoration: "underline",
                    }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t("Main.site")}
                  </a>{" "}
                  {t("Main.site_about")}
                </p>
              </motion.div>
            </div>

            <div className="stats__inner">
              <div className="stats__item">
                <p className="stats__item--val" id="counter">
                  <CountUp
                    start={0}
                    end={daysBetween()}
                    duration={1.5}
                    enableScrollSpy={true}
                    scrollSpyDelay={500}
                  />
                </p>
                <p className="stats__item--text">{t("Main.days")}</p>
              </div>

              <div className="stats__item">
                <p className="stats__item--val">
                  <CountUp
                    start={0}
                    end={stat?.userTotalCount}
                    duration={2}
                    enableScrollSpy={true}
                    scrollSpyDelay={500}
                  />
                </p>

                <p className="stats__item--text">{t("Main.partners")}</p>
              </div>

              <div className="stats__item">
                <p className="stats__item--val">
                  <CountUp
                    start={0}
                    end={stat?.bonusTotalSum}
                    duration={2.5}
                    enableScrollSpy={true}
                    scrollSpyDelay={500}
                    prefix={"$"}
                  />
                </p>

                <p className="stats__item--text">{t("Main.payments")}</p>
              </div>
            </div>

            <button
              onClick={() => navigate("/register")}
              className="button default__button company__button"
            >
              {t("Main.join")}
            </button>
          </div>
        </div>
      </div>

      {/* <RoadMap /> */}

      <div className="mnews">
        <img
          src="/assets/img/wave.png"
          alt="Картинка"
          className="contact__img"
        />

        <div className="container">
          <div className="mnews__inner">
            <p className="mnews__title text__name">{t("Main.news")}</p>

            <Swiper
              className="mnews__content"
              loop
              modules={[Pagination]}
              spaceBetween={30}
              // slidesPerView={publicNews.length > 3 ? 3 : publicNews.length}
              slidesPerView={isLargerThan770 ? 3 : 1}
              pagination={pagination}
              breakpoints={{
                998: {
                  slidesPerView: publicNews.length > 3 ? 3 : publicNews.length,
                },
                768: {
                  slidesPerView: publicNews.length > 3 ? 2 : publicNews.length,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
            >
              {publicNews?.map((news, index) => (
                <SwiperSlide className="mnews__item" key={news.id}>
                  <Link to={`/publick-news/${news.id}`}>
                    <img
                      src={news.imageUrl}
                      className="mnews__item--img"
                      alt="Картинка"
                    />

                    <div className="mnews__item--text">
                      <p className="mnews__item--title">
                        {news.content.find(
                          (e) => e.lang === userData?.interfaceLang
                        )?.title ??
                          news.content.find((e) => e.lang === LangEnum.Ru)
                            ?.title}
                      </p>

                      <p className="mnews__item--subtitle">
                        {news.content.find(
                          (e) => e.lang === userData?.interfaceLang
                        )?.preview ??
                          news.content.find((e) => e.lang === LangEnum.Ru)
                            ?.preview}
                      </p>

                      <p className="mnews__item--date">
                        <img
                          className="mnews__item--date--icon"
                          alt="Иконка"
                          src="/assets/img/date.svg"
                        />
                        <Moment format="DD MMMM YYYY, hh:mm:ss">
                          {news.publishedAt}
                        </Moment>
                      </p>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="last__inner">
              <div className="last__content">
                <div className="last__title">{t("Main.operations")}</div>

                <motion.div
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: isLargerThan770 ? 0.6 : 0.2 }}
                  className="last__wrapper"
                >
                  <div className="last__wrapper--item">
                    <p className="last__wrapper--date grey">{t("Main.date")}</p>

                    <p className="last__wrapper--login grey">
                      {t("Main.login")}
                    </p>

                    <p className="last__wrapper--total grey">
                      {t("Main.total")} ($)
                    </p>
                  </div>

                  {lastOperations?.map((operation, index) => (
                    <motion.div
                      variants={listAnimation}
                      custom={index}
                      className="last__wrapper--item"
                      key={index}
                    >
                      <p className="last__wrapper--date">
                        <Moment format="DD MMMM YYYY, hh:mm:ss">
                          {operation?.date}
                        </Moment>
                      </p>

                      <p className="last__wrapper--login">
                        {replaceSymbolToDots(operation?.userLogin)}
                      </p>

                      <p className="last__wrapper--total">
                        {operation?.amount}
                      </p>
                    </motion.div>
                  ))}
                </motion.div>
              </div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.7, once: true }}
                className="last__review"
              >
                <div className="last__title">
                  {t("Main.review")}
                  <Link to="/reviews">
                    <img src="/assets/img/arrow-blue.svg" alt="Стрелка" />
                  </Link>
                </div>

                <div className="last__wrapper">
                  {publicReviews?.items?.map((review, index) => (
                    <motion.div
                      variants={listAnimation}
                      custom={index}
                      className="last__review--item"
                      key={review?.id}
                    >
                      <Avatar
                        w="120px"
                        h="120px"
                        mx={4}
                        name={
                          review?.user?.name
                            ? review?.user?.name
                            : review?.user?.login
                        }
                        src={review?.user?.imageUrl}
                      />
                      <Flex
                        direction="column"
                        w={["100%", "60%"]}
                        alignItems="start"
                      >
                        <p className="review__item--name">
                          {review?.user?.name
                            ? review?.user?.name
                            : review?.user?.login}
                        </p>

                        <p className="review__item--text">{review?.text}</p>
                        <Text color="#158aff" fontSize={16}>
                          <Moment format="DD MMMM YYYY, hh:mm:ss">
                            {review?.createdAt}
                          </Moment>
                        </Text>
                      </Flex>
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
